// isFinite,
var isNil = function (value) {
    /**
     * isNil(null) => true
     * isNil() => true
     */
    return value === null || value === undefined;
};
export default isNil;
//# sourceMappingURL=is-nil.js.map